/**
 * Initialize various IDE features, themes and cloud regions
 * from an API request. This supplants a configuration object which
 * used to be set at IDE deploy time, not IDE runtime.
 *
 * Now these config settings are reloadable with each refresh. This enables, in
 * conjunction with an Admin Tool, of changing IDE behavior and theming without
 * having to create a new chef databag and re-deploying the app.
 *
 * This also sets a handler for retrieving cloud regions, 'cloud_regions'
 */
import _ from 'underscore';
import Radio from 'backbone.radio';
import Api from '@/lib/api/api';

    var apiCh = Radio.channel('api');

    /**
     * Retrieve the cloud settings from the API and do something with it
     */
    function cloud_config_init(options) {
        var config_fetch_options = {
            type: 'GET',
            url: Api.urls.cloud_config(),
            headers: {
                'Content-type': 'application/vnd.api+json'
            },
            noauth: true
        };
        /** 
        * Set app globals based on cloud settings
        */
        function set_cloud_options(resp) {
            options.features = _.extend({}, options.features, resp.features);
            options.theme = _.extend({}, options.theme, resp.theme);
            options.customCopy = _.extend({}, options.customCopy, resp.customCopy);
 
            var regions = [];
            if (_.isArray(resp.regions)) {
                regions = resp.regions;
            }
            apiCh.reply('cloud_regions', function get_cloud_regions() {
                return regions;
            });
        }
        return Api.ajax(config_fetch_options)
            .done(set_cloud_options)
        ;
    }
    export default cloud_config_init;

